module.exports = __webpack_public_path__ + "img/logo (2).42401a91.png";